import { ForgeProjectInvitation } from "@supernova-studio/model";
import { z } from "zod";
// Updated DTOs to match the database model
export const DTOForgeProjectInvitation = ForgeProjectInvitation;
export const DTOCreateForgeProjectInvitation = DTOForgeProjectInvitation.pick({
    email: true,
    role: true,
});
export const DTOUpdateForgeProjectInvitation = DTOCreateForgeProjectInvitation;
export const DTORemoveForgeProjectInvitation = DTOCreateForgeProjectInvitation.pick({
    email: true,
});
export const DTOForgeProjectInvitationsListResponse = z.object({
    invitations: z.array(DTOForgeProjectInvitation),
});
export const DTOForgeProjectInvitationGetResponse = z.object({
    invitation: DTOForgeProjectInvitation,
});
export const DTOForgeProjectInvitationCreateResponse = z.object({
    invitation: DTOForgeProjectInvitation,
});
export const DTOForgeProjectInvitationUpdateResponse = z.object({
    invitation: DTOForgeProjectInvitation.nullable(),
});
export const DTOForgeProjectInvitationRemoveResponse = z.object({
    ok: z.literal(true),
});
